import { EPResizeMax, EPResizeMin } from '@rsos/assets/icons';
import ToggleButton from '../IconButton';

const MaximizeToggle = ({
  disabled = false,
  isMaximized = false,
  onClick = () => {},
}) => {
  const Icon = isMaximized ? EPResizeMin : EPResizeMax;
  return (
    <ToggleButton
      btnType="secondary"
      disabled={disabled}
      grow={false}
      noMargin
      onClick={onClick}
      dataName="transcript-resize-button"
    >
      <Icon />
    </ToggleButton>
  );
};

export default MaximizeToggle;
